module.exports = __webpack_public_path__ + "static/img/1958_05_06_NYTimes_GalleryReview.1b34ec8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cage/archive/1958_05_06_NYTimes_GalleryReview.jpg
// module id = z/gq
// module chunks = 0